define('app/views/address_form_view',['app/setup', 'app/models/address', 'app/models/city_area_selector',
  'app/views/city_selector_view', 'app/views/suburb_selector_view',
  'app/views/area_selector_view', 'app/views/region_selector_view'
  ], function(takhfifan, Address, cityAreaSelector, citySelectorView,
    suburbSelectorView, areaSelectorView, regionSelectorView
    ) {

  takhfifan.AddressFormView = Backbone.View.extend({

    el: $('.tkh-add-new-address'),

    events: {
      'click .submit': 'save',
      'click .tkh-remove-address': 'destroy',
      'click .tkh-edit-address': 'edit',
      'click .tkh-new-shipping-address': 'newAddress',
      'click .city': 'setCity',
      'click .item-address:not(".tkh-new-shipping-address") .text': 'selectDefault',
      'click .region': 'setRegion',
      'keyup #city' : 'updateCity',
      'change #city' : 'updateCity'
    },

    initialize: function() {
      var _this = this;

      takhfifan.eventHub.on('formkey', function(formKey) {
        _this.model.set('form_key', formKey);
      }, this);

      takhfifan.eventHub.on('address:saved', function(data) {
        _this.saved_slot(data);
      }, this);

      takhfifan.eventHub.on('address:modified', function(data) {
        takhfifan.eventHub.trigger('message:show', {
          type: 'success',
          msg: 'تغییرات انجام شد.'
        });
      }, this);

      takhfifan.eventHub.on('address:error', function(errors) {
        _this.renderErrors(errors);
      }, this);

      takhfifan.eventHub.on('address:updated', function(data) {
        this.new_address_added(data);
      }, this);

      takhfifan.eventHub.on('address:removed', function(data) {
        this.removed_slot(data);
      }, this);

      takhfifan.eventHub.on('address:removed-error', function(data) {
        takhfifan.eventHub.trigger('message:show', {
          type: 'error',
          msg: 'عملیات با خطا مواجه شد.'
        });
      }, this);

      var cityAreaSelector = new takhfifan.CityAreaSelector({
        city: this.$('#city').val()
      });

      this.cityAreaSelectorModel = cityAreaSelector;
      this.cityAreaSelectorModel.on('change', this.updateZoneDetails, this);

      new takhfifan.AreaSelectorView({
        el: this.$('.tkh-areas').first(),
        model: this.cityAreaSelectorModel
      });

      new takhfifan.SuburbSelectorView({
        el: this.$('.tkh-suburbs').first(),
        model: this.cityAreaSelectorModel
      });

      Backbone.Validation.bind(this);
      this.render();
    },

    updateZoneDetails: function(event) {
      this.model.area=this.cityAreaSelectorModel.get('area');
      this.model.suburb=this.cityAreaSelectorModel.get('suburb');
    },

    updateCity: function(event) {
      var city = $(event.target).val();
      this.cityAreaSelectorModel.set('city', city);
    },

    render: function() {
    },

    renderErrors: function(errors) {
      this.$('.success').empty().hide();
      var $errors = this.$('.alert-error');
      $errors.empty();
      _.each(errors, function(e) {
        var preFormattedError='<div class="alert alert-red"><span class="icon-info"></span><p>'+
          e+
        '</p></div>';
        var $li = $('<li></li>');
        $li.html(preFormattedError);
        $errors.append($li);
      });
      $errors.show();
    },

    save: function(e) {
      e.preventDefault();

      this.updateModel();

      if (this.model.isValid()) {

        var url = this.$el.data('submit-to');
        var form = $('.tkh-address-form');
        var id = form.attr('data-edit-id');

        if ( id != undefined) {
          url = form.data('edit-url') + id;
        }
        this.model.save(url);

      } else {
        e.preventDefault();
        this.$('.alert-error').slideDown();
      }
    },

    saved_slot: function(data) {
      var form = $('.tkh-address-form');
      var edit_id = form.attr('data-edit-id');

      if (edit_id == undefined) {
        var template = _.template($('#address-template').html());

        var compiled_template = template({
          address: data, address_json: JSON.stringify(data)
        });
        if(this.$('.item-address:not(".tkh-new-shipping-address")').length>0) {
          var newAddreeObj=$('<div/>').html(compiled_template);
          newAddreeObj.children().first().insertAfter(this.$('.item-address:not(".tkh-new-shipping-address")').last());
        }
        else {
          this.$('.address-list').prepend(compiled_template);
        }
        this.$('.tkh-new-shipping-address').first().remove();
      }
      else {
        var target_address = $("#address" + edit_id);
        target_address.find('.address-city').text(data.region + ", " + data.city);
        target_address.find('.address').text(data.street[0]);
        target_address.find('.postal-code').text(data.postcode);
        form.removeAttr('data-edit-id');
        target_address.attr('data-address', JSON.stringify(data));

      }
      this.$('.tkh-error').hide();
      this.model.clear();
      this.$('input').val('');
      this.$('.region .default-text .value').text('انتخاب کنید');
      takhfifan.eventHub.trigger('message:show', { msg: 'آدرس با موفقیت اضافه شد.',
       type: 'success' });

    },

    updateModel: function() {
      var data = takhfifan.Helper.serializeToObject(this);
      this.model.set(data, { validate: true });
    },

    loadFormData: function(data) {
      if (_.isNull(data)) {
        this.model.clearFormData(data);
      } else {
        this.model.loadFormData(data);
      }

      this.render();
    },

    validate: function() {
      if (this.model.validate() && !this.model.isValid()) {
        this.$('.alert-error').show();
      }
    },

    toggleVisibility: function() {
      this.$el.slideToggle();
    },

    setRegion: function(e) {
      var $target = $(e.target);
      var regionId = $target.data('regionId');
      var regionName = $target.data('region');
      $('input[name="region_id"]').val(regionId);
      this.model.set({
        'regionName': regionName,
        'region': regionName,
        'region_id': regionId
      }, { validate: false });
      this.render();
    },

    setCity: function(e) {
      var $target = $(e.target);
      this.model.set({
        'city': $target.data('city-id')
      });
      this.render();
    },

    destroy: function(e) {
      e.preventDefault();
      console.group('Destroy Action');
      var id = $(e.target).data('id');
      if (confirm('آیا واقعا حذف شود؟')) {
        this.model.destroy(id);
      }
      console.groupEnd();
    },

    removed_slot: function(params) {
      $("#address" + params.id).remove();
      takhfifan.eventHub.trigger('message:show', { msg: 'آدرس با موفقیت حذف شد.',
       type: 'success' });
      var template = _.template($('#new-address-template').html());
      var compiled_template = template({});
      if(this.$('.item-address:not(".tkh-new-shipping-address")').length < 4) {
        this.$('.address-list').append(compiled_template);
      }
    },

    selectDefault: function(e) {
      var id = $(e.target).parents('.item-address').attr('data-id');
      var path = '/customer/address/default/' + id;

      $.ajax({
        url: path,
        type: 'POST',
        data: { form_key: this.model.get('form_key') },
        dataType: 'json',
        success:function(data) {
          $('.item-address').removeClass('active');
          $('.item-address[data-id=' + id + ']').addClass('active');
          takhfifan.eventHub.trigger('address:modified', { id: id });
        },
        error: function(data, a, b){
          takhfifan.eventHub.trigger('address:removed-error', { id: id });
        }});
    },

    newAddress: function(e) {
      this.$('input').val('');
      this.$('.tkh-address-form').removeAttr('data-edit-id');
    },

    edit: function(e) {
      var id = $(e.target).attr('data-id');

      try {
        var data = JSON.parse($('#address' + id).attr('data-address'));
      } catch(err) {
        takhfifan.airbrake.notify(err);
      }

      this.$('input[name=city]').val(data['city']);
      this.$('input[name=postcode]').val(data['postcode']);
      this.$('input[name=telephone]').val(data['telephone']);
      this.$('input[name="street[0]"]').val(data['street']);
      this.$('#region_id li[data-region-id="' + region_id + '"]').addClass("active");
      this.$('.region .default-text .value').text(data['region']);
      this.$('input[name=region_id]').val(data['region_id']);

      this.model.set({ region: data['region'], region_id: data['region_id']});
      this.$('.tkh-address-form').attr('data-edit-id', id);
      this.cityAreaSelectorModel.set('city', data['city']);

    }

  });

});

